import React, { useEffect, useState } from "react";

import "../../App.css";

interface OverlayProps {
  noAccesText?: string;
}

export const Overlay: React.FC<OverlayProps> = ({ noAccesText = "" }) => {
  const overlayHeight = "69px";

  return (
    <div
      className="overlay"
      style={{ marginTop: overlayHeight, paddingBottom: overlayHeight }}
    >
      <p className="overlayText">{noAccesText}</p>
    </div>
  );
};
